module.exports = __webpack_public_path__ + "img/123.ea163959.jpg";